import { CONTENT_TYPE } from '../../../constants';

export const TYPE_AUDIO = CONTENT_TYPE.AUDIO;
export const TYPE_IMAGE = CONTENT_TYPE.IMAGE;
export const TYPE_SHAPE = CONTENT_TYPE.SHAPE;
export const TYPE_SVG = CONTENT_TYPE.SVG;
export const TYPE_TEXT = CONTENT_TYPE.TEXT;
export const TYPE_VIDEO = CONTENT_TYPE.VIDEO;

export const SIMPLE_LAYER_TYPES = [
  TYPE_AUDIO,
  TYPE_IMAGE,
  TYPE_SHAPE,
  TYPE_SVG,
  TYPE_TEXT,
  TYPE_VIDEO,
];

export const SIMPLE_LAYER_TYPE_SET = new Set(SIMPLE_LAYER_TYPES);
export const TYPES_WITH_BOUNDS = new Set([
  TYPE_IMAGE,
  TYPE_SVG,
  TYPE_TEXT,
  TYPE_VIDEO,
]);

export const LAYER_EDITOR_CONTENT_TYPE = new Set([
  CONTENT_TYPE.IMAGE,
  CONTENT_TYPE.SVG,
  CONTENT_TYPE.VIDEO,
]);

export const PREVIEW_THUMBNAIL = 200;

export const PANEL_PADDING = 15;
export const DOUBLE_PANEL_PADDING = PANEL_PADDING * 2; // pixels
